import SEO from '../../seo/SEO'
import './Privacidad.css'

const Privacidad = () => {
  return (
    <>
      <SEO 
        title="Política de Privacidad"
        description="Política de privacidad del Estudio Contable Vanesa Mondejar. Conocé cómo protegemos y utilizamos tu información personal."
        canonical="https://vanesamondejar.com/privacidad"
        keywords="política de privacidad, estudio contable, protección de datos, confidencialidad"
      />
      
      <main className="legal-page">
        <section className="legal-hero">
          <div className="container">
            <h1 className="legal-hero__title">Política de Privacidad</h1>
            <p className="legal-hero__updated">Última actualización: Febrero 2025</p>
          </div>
        </section>

        <section className="legal-content">
          <div className="container">
            <div className="legal-content__wrapper">
              <div className="legal-content__block">
                <h2>1. Responsable del tratamiento</h2>
                <p>
                  El Estudio Contable Vanesa Mondejar es el responsable del tratamiento de los datos personales 
                  que los usuarios facilitan a través del presente sitio web. Nos comprometemos a proteger la 
                  privacidad de toda persona que nos proporcione información personal.
                </p>
              </div>

              <div className="legal-content__block">
                <h2>2. Datos que recabamos</h2>
                <p>
                  Podemos recoger datos de carácter personal cuando el usuario utiliza el formulario de contacto, 
                  nos envía un correo electrónico o establece comunicación con nosotros por cualquier otro medio. 
                  Los datos que podemos solicitar incluyen, sin carácter exhaustivo: nombre completo, dirección de 
                  correo electrónico, número de teléfono y el contenido del mensaje o consulta.
                </p>
              </div>

              <div className="legal-content__block">
                <h2>3. Finalidad del tratamiento</h2>
                <p>
                  Los datos personales facilitados serán utilizados exclusivamente para atender las consultas 
                  formuladas, gestionar la relación profesional con el cliente y, en su caso, prestar los 
                  servicios contables y asesoramiento solicitados. No se utilizarán los datos para fines 
                  distintos de los indicados sin consentimiento previo del interesado.
                </p>
              </div>

              <div className="legal-content__block">
                <h2>4. Base jurídica</h2>
                <p>
                  El tratamiento de los datos personales se realiza sobre la base del consentimiento del usuario 
                  al enviar el formulario o establecer contacto con nosotros, así como en la ejecución de 
                  precontratos o contratos cuando exista relación profesional.
                </p>
              </div>

              <div className="legal-content__block">
                <h2>5. Conservación de los datos</h2>
                <p>
                  Los datos personales serán conservados durante el tiempo necesario para cumplir con la finalidad 
                  para la que fueron recabados y para atender las obligaciones legales que correspondan. Una vez 
                  finalizado el tratamiento, los datos serán bloqueados o eliminados de forma segura.
                </p>
              </div>

              <div className="legal-content__block">
                <h2>6. Confidencialidad y seguridad</h2>
                <p>
                  Como estudio contable, aplicamos las medidas técnicas y organizativas necesarias para garantizar 
                  la seguridad e integridad de los datos personales, evitando su alteración, pérdida, tratamiento 
                  no autorizado o acceso indebido. El deber de confidencialidad es un pilar fundamental de nuestra 
                  actividad profesional.
                </p>
              </div>

              <div className="legal-content__block">
                <h2>7. Derechos del interesado</h2>
                <p>
                  Los usuarios pueden ejercer sus derechos de acceso, rectificación, supresión, limitación del 
                  tratamiento, oposición y portabilidad, así como el derecho a presentar una reclamación ante la 
                  autoridad de control competente. Para ejercer cualquiera de estos derechos, pueden contactarnos 
                  a través del correo electrónico o los canales de contacto indicados en este sitio web.
                </p>
              </div>

              <div className="legal-content__block">
                <h2>8. Cesión de datos</h2>
                <p>
                  No se ceden datos personales a terceros salvo obligación legal o cuando sea estrictamente 
                  necesario para la prestación del servicio contratado (por ejemplo, ante organismos públicos 
                  cuando la normativa lo exija en el marco de nuestra actividad como estudio contable).
                </p>
              </div>

              <div className="legal-content__block">
                <h2>9. Cookies</h2>
                <p>
                  Este sitio web puede utilizar cookies u otras tecnologías similares para mejorar la experiencia 
                  del usuario. Las cookies son pequeños archivos que se almacenan en el dispositivo del visitante. 
                  El usuario puede configurar su navegador para rechazar cookies, si bien esto puede afectar 
                  algunas funcionalidades del sitio.
                </p>
              </div>

              <div className="legal-content__block">
                <h2>10. Modificaciones</h2>
                <p>
                  Nos reservamos el derecho de modificar la presente política de privacidad para adaptarla a 
                  novedades legislativas o jurisprudenciales, así como a prácticas del sector. Se recomienda 
                  revisar periódicamente esta página para estar informado de cualquier cambio.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  )
}

export default Privacidad
